var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLitecoin = function SvgLitecoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.398,
    cy: 12.534,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.592 12.929-1.248 4.212h6.677a.342.342 0 0 1 .328.438l-.58 2a.459.459 0 0 1-.442.33H7.13l1.724-5.822-1.907.58.42-1.36 1.91-.581 2.421-8.18a.456.456 0 0 1 .439-.334h2.583a.343.343 0 0 1 .331.435l-2.032 6.918 1.907-.581-.409 1.384-1.925.56Z",
    fill: "#000"
  })));
};

export default SvgLitecoin;